import { ButtonVariant, CellType, IButtonProps } from '@amobee/component-library';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';
import { TableConfigs } from 'src/app/common/components/data-table/data-table.component';

@Component({
  selector: 'brand-sheet',
  templateUrl: './brand-sheet.component.html',
  styleUrls: ['./brand-sheet.component.scss']
})
export class BrandSheetComponent implements OnInit {

  @Input() brandDetail: any;
  @Input() open: boolean = false;
  @Output() close = new EventEmitter();

  okButton: IButtonProps = {
    variant: ButtonVariant.PRIMARY,
    label: 'OK',
    onClick: () => {
      this.open = false;
      this.close.emit();
    }
  };

  showContentLoading: boolean = false;
  tableConfigs: TableConfigs = {
    disableSorting: true,
    uniqueIdAccessor: 'Id',
    pageSize: 25, // default to 25
    isSelectionEnabled: false,
    isPaginationEnabled: true,
    showSummaryRow: false,
    stickyHeader: false,
    stickyColumnHeaders: false,
    enableStickyColumns: false,
    fetchStaticData: () => {
      this.showContentLoading = true;
      return this.campaignAdapter.getBrandIds(this.brandDetail.customerId, this.brandDetail.advertiserId).then((value) => {
        this.showContentLoading = false;
        return {
          results: value,
          count: value.length
        };
      });
    }
  };
  columns: any[] = [
    {
      Header: 'Brand Name',
      accessor: 'Name',
      id: 'name',
      isRowActionColumn: true,
      cellType: CellType.LINK,
      onLinkClick: row => {
        this.showContentLoading = true;
        this.campaignAdapter.updateCBAId(this.brandDetail.customerId, this.brandDetail.advertiserId, row.original.Id);
        this.router.navigate(['campaign/list']).catch(() => {
          this.showContentLoading = false;
        });
      },
      isActive: () => true
    }
  ];
  constructor(
    private campaignAdapter: CampaignAdapter,
    private router: Router
  ) {
  }

  ngOnInit() {
  }

  cancel() {
    this.open = false;
    this.close.emit();
  }

}
